import secureLocalStorage from 'react-secure-storage';

export const addToStorage = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
};

export const getFromStorage = key => {
    const data = localStorage.getItem(key);
    return JSON.parse(data);
};

export const removeFromStorage = key => {
    localStorage.removeItem(key);
};

export const addToSession = (key, data) => {
    sessionStorage.setItem(key, JSON.stringify(data));
};

export const getFromSession = key => {
    const data = sessionStorage.getItem(key);
    return JSON.parse(data);
};

export const removeFromSession = key => {
    sessionStorage.removeItem(key);
};

export const addToSecureStorage = (key, data) => {
    secureLocalStorage.setItem(key, JSON.stringify(data));
};

export const getFromSecureStorage = key => {
    const data = secureLocalStorage.getItem(key);
    return JSON.parse(data);
};

export const removeFromSecureStorage = key => {
    secureLocalStorage.removeItem(key);
};